import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PageMetadata from './page-metadata';
import Sections from './sections';
import { includeWhen } from '../react-utils';
import { pagePropType } from '../../models/page';
import { interpretMetadata } from '../../models/page-metadata';
import { stringSubstitution } from './util';

const PageWrapper = styled('main')`
  isolation: isolate; // keep our z-indices in line.
`

const H1 = styled('h1')`
// old uic class
  font-family: 'Space Grotesk', sans-serif;
  font-size: 3rem;
  line-height: 3rem;
`

/**
 * Renders components based off of Contentful Page Model :
 * example: https://app.contentful.com/spaces/ljtyf78xujn2/entries/3ryy5hMRpuCkWEGUIEkQ68
 */
const Page = (props) => {
  const {
    pageType,
    title, // H1 tag at top of page
    pageTitleText, // Deprecated, use pageMetadata from Contentful instead
    metaDescription,
    stringSubstitutions,
    pageMetadata,
    className,
  } = props;

  const head = includeWhen(
    pageType === 'standalone',
    () => (
      <PageMetadata
        {...interpretMetadata(pageMetadata, stringSubstitutions)}
        pageTitleText={pageTitleText || title}
        metaDescription={stringSubstitution(metaDescription, stringSubstitutions)}
      />
    ),
  );

  const header = includeWhen(
    title,
    () => <H1 className='h1'>{stringSubstitution(title, stringSubstitutions)}</H1>,
  );

  return (
    <PageWrapper className={`Page ${className}`}>
      {head}
      {header}
      <Sections {...props} className='content' />
    </PageWrapper>
  );
};

Page.propTypes = {
  ...pagePropType,
  className: PropTypes.string,
};

Page.defaultProps = {
  className: '',
};

export default Page;
